import { Component, Inject } from '@angular/core';
import { FilaProdImprod } from '../../../models/fila-produtivo-improdutivo';
import { ToastState as ts } from '../../../../../shared/enums/toast-state.enum';

import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { ModalComponent } from '../../../../../shared/components/modal/modal.component';
import { InputComponent } from '../../../../../shared/components/input/input.component';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { SelectComponent } from '../../../../../shared/components/select/select.component';
import { DropDownOption } from '../../../../../shared/models/drop-down-option';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecebimentoService } from '../../../../../shared/services/recebimento.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { DropDownHelper } from '../../../../../shared/helpers/dropdown.helper';
import { DateHelper } from '../../../../../shared/helpers/date.helper';
import { FaseId } from '../../../../../shared/enums/fase.enum';
import { ModalService } from '../../../../../shared/services/modal.service';
import { ButtonVariant } from '../../../../../shared/enums/button-variant.enum';

@Component({
  selector: 'app-sla-dialog-produtivo',
  imports: [
    SelectComponent,
    ButtonComponent,
    InputComponent,
    ModalComponent,
    TegelModule,
    ReactiveFormsModule,
  ],
  templateUrl: './sla-dialog-produtivo.component.html',
  styleUrl: './sla-dialog-produtivo.component.scss',
})
export class SlaDialogProdutivoComponent {
  public fase = FaseId;

  form: FormGroup;
  direcionamentoOptions: DropDownOption[] = [];
  filaId: number;
  recebimentoId: number;

  constructor(
    private dialogRef: MatDialogRef<SlaDialogProdutivoComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private fb: FormBuilder,
    private workflowService: RecebimentoService,
    private toast: ToastService,
    private modal: ModalService,
  ) {
    this.direcionamentoOptions = DropDownHelper.stringArrayToOptions([
      'Cabinas',
      'Chassis',
      'Expedição PBD',
      'KD',
      'Motores',
      'Protótipo',
      'Transmissão',
    ]);

    this.filaId = data.id;
    this.recebimentoId = data.recebimentoId;

    const formattedDataEntrada = DateHelper.utcToLocalString(
      data.dataEntrada,
      'dd/MM/yyyy HH:mm:ss',
    );

    this.form = this.fb.group({
      senha: data.senha,
      dataEntrada: formattedDataEntrada,
      registro: [data?.recebimento?.registro ?? ''],
      notaFiscal: [data?.recebimento?.notaFiscal ?? ''],
      fornecedor: [data?.recebimento?.fornecedor ?? ''],
      direcionamento: [data?.recebimento?.direcionamento ?? ''],
      observacao: [data?.recebimento?.observacao ?? ''],
      volume: [data?.recebimento?.volume ?? 0],
      quantidadeLinhas: [data?.recebimento?.quantidadeLinhas ?? 0],
      critico: [data?.recebimento.critico ?? false],
      milkrun: [data?.recebimento.milkrun ?? false],
      controlCenter: [data?.recebimento?.controlCenter ?? false],
    });
  }

  processar(proximaFaseId: number) {
    if (this.form.invalid) {
      this.toast.showToast(ts.error, 'Formulário inválido.');
      return;
    }

    const formValues = this.form.value;

    const dto: FilaProdImprod = {
      filaId: this.filaId,
      recebimentoId: this.recebimentoId,
      proximaFaseId: proximaFaseId,
      fornecedor: formValues.fornecedor,
      registro: formValues.registro,
      notaFiscal: formValues.notaFiscal,
      volume: formValues.volume,
      direcionamento: formValues.direcionamento,
      quantidadeLinhas: formValues.quantidadeLinhas,
      observacao: formValues.observacao,
      critico: formValues.critico,
      milkrun: formValues.milkrun,
      controlCenter: formValues.controlCenter,
      subidaDireta: false,
    };

    if (proximaFaseId === FaseId.DAR_BAIXA) {
      this.openConfirmationDialog(dto);
    } else {
      this.executarProcessamento(dto);
    }
  }

  private openConfirmationDialog(dto: FilaProdImprod) {
    const dialog = this.modal.openConfirmationModal(
      'Dar Baixa no Recebimento',
      'Você tem certeza que deseja dar baixa neste item?',
      'Sim',
      ButtonVariant.p,
      'Cancelar',
      ButtonVariant.s,
    );

    dialog.subscribe((result) => {
      if (result) {
        this.executarProcessamento(dto);
      }
    });
  }

  private executarProcessamento(dto: FilaProdImprod) {
    this.workflowService.processamentoProdImprod(dto).subscribe({
      next: () => {
        this.toast.showToast(ts.success, 'Processado com sucesso!');
        this.dialogRef.close(true);
      },
      error: (e) => this.toast.showToast(ts.error, e.error[0]),
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
